import Vue from 'vue';
import {combineText,setCursorAfter} from '../../utils/domHelper';

const ENTER_CODE = 13;
Vue.directive('ignore-enter',{
    inserted(el,binding){
        el.addEventListener(
            "keydown",
            event => {
                if (event.charCode == ENTER_CODE || event.key == "Enter") {
                    event.preventDefault();
                }
            },
            true
        );
    }
});

Vue.directive('just-text',{
    inserted(el,binding){
        el.addEventListener("paste", ev => {
            if (ev.clipboardData) {
                ev.preventDefault();
                const clipboardData = ev.clipboardData;
                const text = clipboardData.getData("text");
                if (text && text.length > 0 && window.getSelection) {
                    const textNode = document.createTextNode(text);
                    let range = window.getSelection().getRangeAt(0);
                    range.deleteContents();
                    range.insertNode(textNode);
                    range.setStartAfter(textNode);
                    range.detach();

                    const combineTextNode = combineText(textNode);
                    setCursorAfter(combineTextNode);
                }
            }
        });
    }
})